import { createContext, useContext, type ReactNode } from "react";

/** When set, A1 list/form pages navigate under `/sd/admin/...` instead of main app paths */
export type A1EmbedNavConfig = {
  schemas: string;
  schemaAdd: string;
  schemaEdit: (name: string) => string;
  /** Schema “view” / form preview */
  schemaRender: (name: string) => string;
  /** Dynamic module grid + add/edit */
  module: (schemaName: string) => string;
  moduleAdd: (schemaName: string) => string;
  moduleEdit: (schemaName: string, id: string) => string;
  /** Print preview */
  print: (schemaName: string, recordId: string) => string;
  imports: string;
  importAdd: string;
  importDetail: (id: string) => string;
  permissions: string;
  roles: string;
  roleAdd: string;
  roleEdit: (id: string) => string;
  users: string;
  userAdd: string;
  userEdit: (id: string) => string;
  slaConfiguration: string;
  slaConfigurationAdd: string;
};

const A1EmbedNavigationContext = createContext<A1EmbedNavConfig | null>(null);

export function A1EmbedNavigationProvider({
  value,
  children,
}: {
  value: A1EmbedNavConfig | null;
  children: ReactNode;
}) {
  return (
    <A1EmbedNavigationContext.Provider value={value}>
      {children}
    </A1EmbedNavigationContext.Provider>
  );
}

export function useA1EmbedNav(): A1EmbedNavConfig | null {
  return useContext(A1EmbedNavigationContext);
}
